/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_4_DInputs */

const en_tut_part_4_d = /** @type {(inputs: Tut_Part_4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From a quick call inside one room to recordings and a draft summary.`)
};

const id_tut_part_4_d = /** @type {(inputs: Tut_Part_4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari panggilan singkat di satu ruang sampai rekaman dan draf ringkasan.`)
};

/**
* | output |
* | --- |
* | "From a quick call inside one room to recordings and a draft summary." |
*
* @param {Tut_Part_4_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_4_d = /** @type {((inputs?: Tut_Part_4_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_4_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_4_d(inputs)
	return en_tut_part_4_d(inputs)
});